import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export const usePutWordStatus = (successCallback?: () => void): UseMutationResult<null, Error, { id: number }, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, { id: number }>({
        mutationFn: async ({ id }: { id: number }) => {
            const response = await axios.put(
                `${enum_api_uri.put_word_status.replace(":word_idx", id.toString())}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: ["getWordInfo", id] });
            successCallback?.();
        },
    });
};
